import { AUTOPILOT_LABELS, GEAR_LABELS, SIGNAL_BLINKER_LEFT, SIGNAL_BLINKER_RIGHT, SIGNAL_BRAKE, type Telemetry } from './telemetry';
import { formatG, kmh, toG } from './format';

const PEDAL_FULL = 100;
const G_DOT_RADIUS = 11;

export const HUD_GEARS: readonly { readonly gear: number; readonly label: string }[] = [0, 2, 3, 1].map((gear) => ({ gear, label: GEAR_LABELS[gear]! }));

export interface HudReading {
  readonly speed: string;
  readonly gear: number;
  readonly autopilot: string;
  readonly brake: boolean;
  readonly pedal: number;
  readonly steering: number;
  readonly blinkLeft: boolean;
  readonly blinkRight: boolean;
  readonly gX: number;
  readonly gY: number;
  readonly g: string;
}

export const engaged = (reading: HudReading): boolean => reading.autopilot !== AUTOPILOT_LABELS[0];

export const steeringText = (reading: HudReading): string => `${Math.round(reading.steering)}°`;

export const pedalShare = (reading: HudReading): number => reading.pedal / PEDAL_FULL;

export const gDot = (reading: HudReading): { readonly x: number; readonly y: number } => ({ x: reading.gX * G_DOT_RADIUS, y: -reading.gY * G_DOT_RADIUS });

export function readHud(telemetry: Telemetry, index: number): HudReading {
  const signals = telemetry.signals[index]!;
  const clampG = (value: number): number => Math.max(-1, Math.min(1, toG(value)));
  return {
    speed: String(kmh(telemetry.speed[index]!)),
    gear: telemetry.gear[index]!,
    autopilot: AUTOPILOT_LABELS[telemetry.autopilot[index]!] ?? 'Unknown',
    brake: (signals & SIGNAL_BRAKE) !== 0,
    pedal: Math.max(0, Math.min(PEDAL_FULL, telemetry.pedal[index]!)),
    steering: telemetry.steering[index]!,
    blinkLeft: (signals & SIGNAL_BLINKER_LEFT) !== 0,
    blinkRight: (signals & SIGNAL_BLINKER_RIGHT) !== 0,
    gX: clampG(telemetry.accelX[index]!),
    gY: clampG(telemetry.accelY[index]!),
    g: formatG(telemetry.accelX[index]!, telemetry.accelY[index]!),
  };
}
